// Import from skill SKILL.md files — single source of truth
import generalGuide from '../../docs/skills/general-guide/SKILL.md?raw'
import layoutsGuide from '../../docs/skills/layouts-guide/SKILL.md?raw'
import profilesGuide from '../../docs/skills/profiles-guide/SKILL.md?raw'
import chartingGuide from '../../docs/skills/charting-guide/SKILL.md?raw'
import barChartGuide from '../../docs/skills/bar-chart-guide/SKILL.md?raw'
import scannerGuide from '../../docs/skills/scanner-guide/SKILL.md?raw'
import multiScannerGuide from '../../docs/skills/multi-scanner-guide/SKILL.md?raw'
import watchlistGuide from '../../docs/skills/watchlist-guide/SKILL.md?raw'
import calendarGuide from '../../docs/skills/calendar-guide/SKILL.md?raw'
import keyStatsGuide from '../../docs/skills/key-stats-guide/SKILL.md?raw'
import tickerStatsGuide from '../../docs/skills/ticker-stats-guide/SKILL.md?raw'
import notebookGuide from '../../docs/skills/notebook-guide/SKILL.md?raw'
import filtersDashboard from '../../docs/skills/filters-dashboard/SKILL.md?raw'
import filtersHistory from '../../docs/skills/filters-history/SKILL.md?raw'
import columnsDashboard from '../../docs/skills/columns-dashboard/SKILL.md?raw'
import columnsHistory from '../../docs/skills/columns-history/SKILL.md?raw'
import newsGuide from '../../docs/skills/news-guide/SKILL.md?raw'
import metricsGuide from '../../docs/skills/metrics-guide/SKILL.md?raw'
import dilutionGuide from '../../docs/skills/dilution-guide/SKILL.md?raw'
import historyGuide from '../../docs/skills/history-guide/SKILL.md?raw'
import exportsGuide from '../../docs/skills/exports-guide/SKILL.md?raw'

/** Strip YAML frontmatter from SKILL.md content */
function stripFrontmatter(content: string): string {
  const match = content.match(/^---\n[\s\S]*?\n---\n(.*)$/s)
  return match ? match[1].trim() : content
}

/** All skill docs, keyed by skill name. Content has frontmatter stripped. */
export const DOCS: Record<string, string> = {
  'general-guide': stripFrontmatter(generalGuide),
  'layouts-guide': stripFrontmatter(layoutsGuide),
  'profiles-guide': stripFrontmatter(profilesGuide),
  'charting-guide': stripFrontmatter(chartingGuide),
  'bar-chart-guide': stripFrontmatter(barChartGuide),
  'scanner-guide': stripFrontmatter(scannerGuide),
  'multi-scanner-guide': stripFrontmatter(multiScannerGuide),
  'watchlist-guide': stripFrontmatter(watchlistGuide),
  'calendar-guide': stripFrontmatter(calendarGuide),
  'key-stats-guide': stripFrontmatter(keyStatsGuide),
  'ticker-stats-guide': stripFrontmatter(tickerStatsGuide),
  'notebook-guide': stripFrontmatter(notebookGuide),
  'filters-dashboard': stripFrontmatter(filtersDashboard),
  'filters-history': stripFrontmatter(filtersHistory),
  'columns-dashboard': stripFrontmatter(columnsDashboard),
  'columns-history': stripFrontmatter(columnsHistory),
  'news-guide': stripFrontmatter(newsGuide),
  'metrics-guide': stripFrontmatter(metricsGuide),
  'dilution-guide': stripFrontmatter(dilutionGuide),
  'history-guide': stripFrontmatter(historyGuide),
  'exports-guide': stripFrontmatter(exportsGuide),
}
